/**
 * Feature flags Kiltro Scout.
 * Cambia a `true` para activar la sección correspondiente. El código de la
 * sección queda intacto, sólo cambia su visibilidad pública.
 */
export const FEATURE_FLAGS = {
  // Sección "Marcas cerveceras" (/marcas). Cuando se active, se muestra el
  // contenido completo y aparece el enlace en footer / About / nav.
  brandsPublic: false,
};
